// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

import * as React from 'react';
import { css } from 'glamor';
import { withNamespaces } from 'react-i18next';

import { environment } from '../../environments';

type Props = {
  t: (string, string) => string
}

export const Footer = ({ t }: Props) => (
  <div className={`modal-footer ${styles}`}>
    <div className="forgot">
      <a href={`${environment.web}/forgot-password`}>{t('App.Button.ForgotPassword', 'Forgot password?')}</a>
    </div>
    <div className="signup">
      <span>{t('App.LoginForm.DontHaveAccount', 'Don’t have an account?')}</span>
      <a href={`${environment.web}/signup`}>{t('App.Link.Signup', 'SIGN UP')}</a>
    </div>
  </div>
);

export default withNamespaces()(Footer);

const styles = css({
  ' a': {
    fontSize: '12px',
    fontWeight: 500,
    color: 'rgb(28, 159, 208)',
    textTransform: 'uppercase',
    textDecoration: 'none',
  },
  ' .forgot': {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    margin: '20px 0',
  },
  ' .signup': {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    ' span': {
      fontSize: '14px',
      lineHeight: '21px',
    },
    ' a': {
      marginLeft: '10px',
    },
  },
});
